<template>
    <k-panel class="tranche-card" :classes="'border-l border-b border-r'">
        <template v-slot:header>
            <div class="card-image">
                <img v-if="tranche.mainPictureFileReference" class="rounded object-scale-down"
                     :src="`/api/guest/download/${tranche.mainPictureFileReference}`">
            </div>
        </template>
        <div class="card-content border-gray-100">
            <k-panel-row class="mt-1">
                <div slot="left">
                    <span class="font-semibold text-sm text-gray-900">{{ tranche.details.title }}</span>
                </div>
                <div slot="left">
                    <span class="font-medium text-xs text-gray-900">{{ tranche.details.subtitle }}</span>
                </div>
            </k-panel-row>
            <k-panel-row margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/window.svg" class="inline-block mr-2 icon">
                    Industry
                </div>
                <div slot="right">
                    {{ tranche.trancheType | enumValue }}
                </div>
            </k-panel-row>
            <k-panel-row v-if="tranche.borrowerProductTypes" margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/list_ul.svg" class="inline-block mr-2 icon">
                    Product type
                </div>
                <div slot="right">
                    <div v-for="productType in tranche.borrowerProductTypes" :key="productType" class="text-right">
                        {{ productType }}&nbsp;
                    </div>
                </div>
            </k-panel-row>
            <k-panel-row v-if="tranche.details.investmentStructure" margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/code.svg" class="inline-block mr-2 icon">
                    Investment structure
                </div>
                <div slot="right" class="text-right">
                    {{ tranche.details.investmentStructure }}
                </div>
            </k-panel-row>
            <k-panel-row v-if="tranche.collateral" margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/label.svg" class="inline-block mr-2 icon">
                    Security
                </div>
                <div slot="right">
                    <div v-for="collateral in tranche.collateral" :key="collateral" class="text-right">
                        {{ collateral }}&nbsp;
                    </div>
                </div>
            </k-panel-row>
            <k-panel-row margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/pie_chart_outline_25.svg" class="inline-block mr-2 icon">
                    Returns
                </div>
                <div slot="right">{{ tranche.interestRate | numeralFormat('0.00') }}%</div>
            </k-panel-row>
            <k-panel-row v-if="tranche.term" margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/calendar_calendar.svg" class="inline-block mr-2 icon">
                    Term
                </div>
                <div slot="right">
                    {{ tranche.term }}
                </div>
            </k-panel-row>
            <k-panel-row margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/credit_card_alt.svg" class="inline-block mr-2 icon">
                    Available to invest
                </div>
                <div slot="right">{{tranche.currencySymbol}}{{ tranche.principalAvailable | numeralFormat('0,0.') }}</div>
            </k-panel-row>
            <k-panel-row margin="mb-1">
                <div slot="left">
                    <img src="/img/icon/phone.svg" class="inline-block mr-2 icon">
                    Early redemption frequency ({{ tranche.paymentPeriodInTerms }})
                </div>
                <div slot="right">{{ tranche.capitalCallEnabled ? tranche.capitalCallFrequency : 'N/A' }}</div>
            </k-panel-row>
            <k-panel-row  margin="mt-2" v-if="tranche.details.summary.shortDescription">
                <div slot="left" class="border-t pt-2">{{ tranche.details.summary.shortDescription }}</div>
            </k-panel-row>
        </div>
    </k-panel>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            default: () => ({})
        },
    },
};
</script>

<style scoped>
.card-image {
    width: 100%;
    /*height: 200px;*/
    overflow: hidden;
    position: relative;
}

.card-image img {
    width: 100%;
    height: auto;
    max-height: 258px;
    transition: all .5s;
    transform: scale(1.05);
}

.tranche-card {
    padding: 0;
    cursor: pointer;
}

.tranche-card:hover .card-image img {
    transform: scale(1.10);
}

.tranche-card:hover {
    @apply bg-gray-100;
}

.card-content {
    padding: 20px;
}

.icon {
    height: 12px;
    width: 12px;
}
</style>
